<div class="cr-back-button" [ngClass]="cssClasses">
  <button
    mat-button
    [routerLink]="goBack ? null : routerLink"
    (click)="onClick()"
    [matTooltip]="tooltipText"
    [matTooltipDisabled]="!tooltipText"
    matTooltipClass="universalTooltip"
    matTooltipPosition="below"
    matTooltipShowDelay="450">
    <mat-icon>{{ icon }}</mat-icon>
    <ng-content></ng-content>
  </button>
</div>
